import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { withFormik } from 'formik';
import * as yup from 'yup';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import Input from '../../components/Input/Input';
import { cpfMask } from '../../shared/masks';

const styles = theme => ({
  button: {
    borderRadius: '100px',
    margin: theme.spacing(2),
    padding: `${theme.spacing(2)}px ${theme.spacing(6)}px`,
  },
  link: {
    color: theme.palette.text.secondary,
    textDecoration: 'none',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
});

const formFields = [
  {
    elementType: 'input',
    config: {
      type: 'text',
      name: 'mail',
      label: 'Email',
    },
    helperText: ' ',
  },
  {
    elementType: 'maskedInput',
    config: {
      type: 'text',
      name: 'cpf',
      label: 'CPF',
      mask: cpfMask,
    },
    helperText: ' ',
  },
  {
    elementType: 'passwordToggle',
    config: {
      name: 'password',
      label: 'Senha',
    },
    helperText: ' ',
  },
];

const Form = ({
  classes,
  loading,
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
}) => (
  <form onSubmit={handleSubmit}>
    <Grid container justify="center" >
      <Grid item container spacing={2} justify="center" >
        {formFields.map(field => (
          <Grid item key={field.config.name} xs={field.config.name === 'mail' ? 12 : 6} >
            <Input
              {...field.config}
              elementType={field.elementType}
              value={values[field.config.name]}
              onChange={handleChange}
              onBlur={handleBlur}
              fullWidth
              required
              margin="normal"
              error={errors[field.config.name] && touched[field.config.name]}
              helperText={
                (touched[field.config.name] && errors[field.config.name]) || field.helperText
              }
            />
          </Grid>
        ))}
      </Grid>

      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox color="primary" name="terms" checked={values.terms} onChange={handleChange} />
          }
          label={
            <div>
              Li e aceito os{' '}
              <a
                className={classes.link}
                href="https://puntu.digital/terms.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                termos, condições de uso e política de privacidade.
              </a>
            </div>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          className={classes.button}
          disabled={!values.terms || loading}
        >
          {loading ? <CircularProgress size={20} color="primary" /> : 'CADASTRAR'}
        </Button>
      </Grid>
    </Grid>
  </form>
);

const RegisterEmployeeForm = withFormik({
  mapPropsToValues: () => ({
    mail: '',
    password: '',
    cpf: '',
  }),
  validationSchema: yup.object().shape({
    mail: yup
      .string()
      .email()
      .required(),
    password: yup.string().required(),
    cpf: yup.string().required(),
  }),
  handleSubmit: (values, { props }) => {
    const data = { cpf: values.cpf.replace(/\D+/g, ''), password: values.password, email: values.mail.replace(/ /g, ''), gestor: props.gestor };
    props
      .onRegisterEmployee(data)
      .then(() => {
        if (props.gestor) {
          props.history.push({ pathname: '/login' });
        } else {
          props.history.push({ pathname: '/ponto-web', state: { cpf: data.cpf } });
        }
      })
      .catch(error => error);
  },
})(Form);

Form.propTypes = {
  classes: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object,
  touched: PropTypes.object,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleSubmit: PropTypes.func,
};

export default withRouter(withStyles(styles)(RegisterEmployeeForm));
